<template>
  <v-container>
    <v-row class="justify-center">
      <v-col md="4" lg="4" xl="4" sm="12">
        <cashView
          :TotalCash="MaitnCash"
          Title="Cash On Hand"
          :isLoading="loading"
          SubTitle="Lacagta guud Khasnada ku jirto"
        ></cashView>
      </v-col>
      <v-col md="4" lg="4" xl="4" sm="12">
        <cashView
          :isLoading="loading"
          :TotalCash="Receiveble"
          Title="Receivable Cash"
          SubTitle="Lacagta guud ee deymaha kaa maqan"
        ></cashView>
      </v-col>
      <v-col md="4" lg="4" xl="4" sm="12">
        <cashView
          :isLoading="loading"
          :TotalCash="Payable"
          Title="Payable Cash"
          SubTitle="Lacagta guud ee Amaanada"
        ></cashView>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { allReq } from "@/axiosfiles/axios-outh";
import axios from "axios";
import cashView from "@/components/cashView.vue";
export default {
  components: { cashView },
  data() {
    return {
      MaitnCash: [],
      Receiveble: [],
      Payable: [],
      loading: true,
    };
  },
  methods: {
    ShowTotalCash(Account) {
      return allReq.post(`/qarash/totalcash`, {
        Account,
      });
    },
    loadCashes() {
      this.loading = true;
      axios
        .all([
          this.ShowTotalCash("Main Cash"),
          this.ShowTotalCash("Receivable"),
          this.ShowTotalCash("Account payable"),
        ])
        .then(response => {
          // console.log(response);
          this.loading = false;
          this.MaitnCash = response[0].data;
          this.Receiveble = response[1].data;
          this.Payable = response[2].data;
        });
    },
  },
  created() {
    this.loadCashes();
  },
};
</script>
